export const STORE_CART_TAG_CONFIG = 'storeCartTag';
export const STORE_WISHLIST_CONTROLS_CONFIG = 'storeWishlistControls';
export const LUXE_CATALOG_TAG = 'fashion_luxe';
